<template>
  <div>
    <v-dialog v-model="dialogOpen" persistent max-width="400px">
      <v-card>
        <v-card-text>
          <div class="mb-3">
            <h3>{{ formType === 'add' ? 'Add Ads Item' : 'Edit Ads Item' }}</h3>
          </div>
          <v-layout wrap>
            <v-flex xs12 class="form-control pb-3" :class="{ 'has-error': errors.has('fullName') }">
              <span>Ads ID</span><span class="red--text">*</span>
              <v-text-field
                v-model="input.ad_id"
                v-validate="'required'"
                flat
                outline
                solo
                :placeholder="'Ads ID'"
                name="ad_id"
                class="default-input-textfield"
                :data-vv-as="'Ads ID'"
                hide-details
              ></v-text-field>
              <p v-if="errors.has('ads_id')" class="text-error pt-2">
                {{ errors.first('ads_id') }}
              </p>
            </v-flex>
            <v-flex
              xs12
              class="form-control pb-3"
              :class="{ 'has-error': errors.has('customerType') }"
            >
              <span>Type</span><span class="red--text">*</span>
              <v-select
                v-model="input.type"
                v-validate="'required'"
                flat
                outline
                full-width
                :items="assignTypeOptions"
                :item-text="'label'"
                :item-value="'value'"
                solo
                name="pledgeWaterTank"
                :placeholder="'Type'"
                :data-vv-as="'Type'"
                class="default-input-textfield"
                hide-details
              ></v-select>
              <p v-if="errors.has('type')" class="text-error pt-2">
                {{ errors.first('type') }}
              </p>
            </v-flex>
            <v-flex xs12 class="form-control pb-3" :class="{ 'has-error': errors.has('assignTo') }">
              <span>Assign To</span><span class="red--text">*</span>
              <v-select
                v-model="input.assign_to"
                v-validate="'required'"
                flat
                outline
                full-width
                :items="assignToOptions"
                :item-text="'label'"
                :item-value="'value'"
                solo
                name="assignTo"
                :placeholder="'Assign To'"
                :data-vv-as="'Assign To'"
                class="default-input-textfield"
                hide-details
              ></v-select>
              <p v-if="errors.has('assign_to')" class="text-error pt-2">
                {{ errors.first('assign_to') }}
              </p>
            </v-flex>

            <v-flex xs12 class="pt-3 text-xs-center">
              <v-btn outline color="grey" @click="handleCancel">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" depressed @click="handleSaveData">{{ $t('Save') }}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import adsManagementApi from '@/api/ads-management'
import { handleResponse, handleApiError } from '@/api/util'

export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    formType: {
      type: String,
      default: 'add'
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogOpen: false,
      input: {
        ad_id: '',
        type: '',
        assign_to: ''
      },
      assignTypeOptions: [
        { label: 'Group', value: 'group' },
        { label: 'Agent', value: 'agent' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent'
    }),
    assignToOptions() {
      if (this.input.type === 'group') {
        return this.agentGroup.map((item) => {
          return {
            label: item.groupname,
            value: item.id
          }
        })
      } else if (this.input.type === 'agent') {
        return this.agents.map((item) => {
          return {
            label: item.adminid,
            value: item.adminid
          }
        })
      } else {
        return []
      }
    }
  },
  watch: {
    open: {
      handler() {
        this.dialogOpen = this.open
      }
    },
    value: {
      deep: true,
      handler() {
        this.prefillForm()
      }
    }
  },
  async mounted() {
    if (this.agentGroup && this.agentGroup.length === 0) {
      await this.$store.dispatch('loadAgentGroups')
    }

    if (this.agents && this.agents.length === 0) {
      await this.$store.dispatch('loadAgents')
    }

    if (this.value) {
      this.input = this.value
    }
  },

  methods: {
    prefillForm() {
      try {
        if (!this.value) return

        this.input.ad_id = this.value.ad_id
        this.input.type = this.value.type
        this.input.assign_to = this.value.assign_to
      } catch (error) {
        console.error(error)
      }
    },
    async handleSaveData() {
      const vm = this
      try {
        let result = await vm.$validator.validateAll()
        if (!result) {
          vm.goToErrorInput()
          return false
        }

        let response = null
        if (vm.formType === 'add') {
          response = await vm.createAdsItem()
        } else {
          response = await vm.updateAdsItem()
        }

        if (response && response.status === 204) {
          this.$emit('onSaveSuccess')
          this.handleCancel()
        }
      } catch (error) {
        console.error(error)
      }
    },
    async createAdsItem() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          ad_id: vm.input.ad_id,
          type: vm.input.type,
          assign_to: vm.input.assign_to
        }

        const response = await adsManagementApi.postAdsManagement({ data })

        handleResponse(response)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        handleApiError(error)
        return null
      }
    },
    async updateAdsItem() {
      const vm = this
      try {
        if (!vm.value.id) return
        const data = {
          id: vm.value.id,
          page_id: vm.selectedBot.pageid,
          ad_id: vm.input.ad_id,
          type: vm.input.type,
          assign_to: vm.input.assign_to
        }

        const response = await adsManagementApi.putAdsManagement({ data })

        handleResponse(response)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        handleApiError(error)
        return null
      }
    },
    handleCancel() {
      this.input = {
        ad_id: '',
        type: '',
        assign_to: ''
      }

      this.$emit('onClose')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/AdsManagement/AdsManageFormDialog.vue